import clsx from 'clsx';

import styles from './Button.module.scss';

interface ButtonProps {
  className?: string;
  color?: 'primary' | 'secondary' | 'tertiary';
  onClick?: () => void;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

export const Button = ({
  className,
  color = 'primary',
  onClick,
  type = 'button',
  children,
}: ButtonProps) => {
  return (
    <button
      className={clsx(
        styles.button,
        {
          [styles.button_secondary]: color === 'secondary',
          [styles.button_tertiary]: color === 'tertiary',
        },
        className,
      )}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
